<script>
import { generateChart } from 'vue-chartjs'
import 'chartjs-chart-treemap'

const TreeMap = generateChart('tree-map', 'treemap')

export default {
  extends: TreeMap,
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    options: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
    // this.addPlugin(ChartDataLabels)
    this.renderChart(this.data, this.options)
  },
  watch: {
    data() {
      this.renderChart(this.data, this.options)
    }
  }
}
</script>
<style></style>
